import React from "react";
import PageHeader from "../components/PageHeader";
import { commonImg } from "../assets/assets.js";
import "../css/commontemplate.css";

export const Publication = () => {
  return (
    <>
      <PageHeader title="प्रकाशन " path="/about-goshala" name=" goshala" />
      {/* <Initiatives /> */}
      <div className="comman-template-section">
        <div className="comman-template-container">
          {/* container  */}
          <div className="comman-template-sub-section">
            {/* sub-section */}
            <div className="comman-template-img-container">
              <img
                className="comman-template-image"
                src={commonImg.com_publication}
                alt=""
              />
            </div>
            <div className="comman-template-info-container">
              <h3>प्रकाशन विभाग</h3>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp; उपरोक्त संस्थांच्या माध्यमातून
                संयुक्तपणे विविध प्रसंगी अनेक ग्रंथांचे तसेच ध्वनी मुद्रिका
                इत्यादींचे प्रकाशन होत असते. यामध्ये विशेषत्वाने श्रीदाजी गुरुदर्शन चरित्र ग्रंथ, श्रीदाजी कथामृत, श्रीदाजीमहाराज संक्षिप्त
                स्तोत्र, इत्यादी अनेक ग्रंथांचा समावेश आहे.
              </p>
            </div>
          </div>
          {/* second one  */}

          <div className="comman-template-sub-section"></div>
        </div>
      </div>
    </>
  );
};
